const errorPayload = (message: string) => ({ payload: message });
const stringPayload = (value: string) => ({ payload: value });
const numberPayload = (value: number) => ({ payload: value });
const booleanPayload = (value: boolean) => ({ payload: value });
// const Action = (featureKey: string, description: string, payload?: (...args: any[]) => Props<object>) =>
// 	createAction(`[${featureKey}] ${description}`, payload);

export const ActionUtil = {
  errorPayload,
  stringPayload,
  numberPayload,
  booleanPayload,
  // Action,
};
